interface IRegulation {
  '1': string;
  '2': string;
  '3': string;
  '4': string;
  '5': string;
}
export const REGULATION: IRegulation | any = {
  '1': '利用規約/契約書',
  '2': '利用規約',
  '3': '利用規約',
  '4': '利用規約',
  '5': 'プライバシーポリシー',
};
